import DEFAULT_ROUTES from '../../constants/routes';

export const TEST_GROUP_EMPTY_CONTENT = {
  title: 'Group your test cases for execution',
  description:
    'A test group is a collection of test cases you run together — by feature, release, or regression scope. Create a group, add cases, then launch it against any environment.',
  createButtonLabel: 'Create test group',
  howItWorksButtonLabel: 'How it works',
  howItWorksCardTitle: 'HOW TEST GROUPS WORK',
  steps: [
    {
      title: 'Create a group',
      description: 'give it a name and type (e.g. regression, smoke)',
    },
    {
      title: 'Add test cases',
      description: 'pick from your existing test case library',
    },
    {
      title: 'Launch it',
      description: 'run the group against an environment; results tracked automatically',
    },
  ],
  warningMessage: "You'll need at least one test case before adding cases to a group.",
  testCasesLinkLabel: 'Go to Test Cases',
};

export const HOW_IT_WORKS_DOCS_PATH = `${DEFAULT_ROUTES.DOCS}/test-runs-execution`;

export const getTestCasesRoute = (projectId) => (
  `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${projectId}${DEFAULT_ROUTES.TEST_CASES}`
);
